import React, { useContext } from "react";
// import Box from "@mui/material/Box";
// import Fab from "@mui/material/Fab";
import instance from "../api/api";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AddShoppingCart from "@mui/icons-material/AddShoppingCart";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import {
  Button,
  CardActionArea,
  CardActions,
  CircularProgress,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import { makeStyles } from "@mui/styles";
// import { createMuiTheme } from '@mui/styles';
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import AspectRatio from "@mui/joy/AspectRatio";
import { Context } from "../context/ContextProvider";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import data from "./../api/Data";
import { Box } from "@mui/system";
import Grid from "@mui/material/Unstable_Grid2";
import { DeleteForever, IcecreamOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Container } from "semantic-ui-react";
// import IconButton from "@material-ui/core/IconButton";
import { IconButtonRoot } from "@mui/joy/IconButton/IconButton";

const useStyles = makeStyles((theme) => ({
  default_tabStyle: {
    color: "green",
    fontSize: 11,
    backgroundColor: "red",
  },
  customHoverFocus: {
    // backgroundColor: "green",
    color: "green",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "black", color: "red" },
    marginTop: 10,
    // borderRadius: 5,
    // height: "40px",
  },
}));

const HomeList = ({ t, i18n }) => {
  const classes = useStyles();
  const ddd = data.ProductItems;
  const textCutFunc = (text) =>
    `${text
      .trim()
      .split(" ")
      .splice(0, text?.length > 25 ? 4 : 5)
      .join(" ")}  ${text?.length > 25 ? "..." : ""}`;

  const {
    categories,
    items,
    setItems,
    addOrder,
    setOrders,
    orders,
    newList,
    setNewList,
    amountOfItemsInCart,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
  } = useContext(Context);

  const cartFull = cartItmes
    .map((item) => item.qty)
    .reduce((previous, item) => previous + item, 0);
  const [select, setSelect] = React.useState("all");
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = React.useState(true);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "red" : "#ffffff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    // width: "100%",
    // paddingTop:theme.spacing(3),
    // marginRight:theme.spacing(1),
    // textAlign: "center",
  }));

  React.useEffect(() => {
    console.log("items: ", items[0]);
  }, [items, orders]);

  const filterItems = (category) => {
    // toTop();
    // console.log("orders filter ... : ",orders);
    // Haptics.selectionAsync();
    // console.log("dd: ",category);
    // const jj  = categories.filter((c,k)=>k===category)
    // console.log("jj: ",jj);
    if (category === "all") {
      setItems(items);
      // console.log("orders all : ", orders);
      setSelect("all");
      // setScrollEnabled(true);
      return;
    }
    // console.log("orders filter: ", orders);
    // setOrders(orders);
    // setOrders(dataItem);

    const newItems = items.filter((item) => item.category === category);
    // setItems(newItems);
    // let jj =  newItems
    // console.log("orders filter category: ", newItems);

    // console.log("orders filter category: ", jj[0].category);
    // setOrders(jj)

    if (newItems.length > 0) {
      setSelect(newItems[0].category);
      // console.log('select: ',newItems[0].category );
      // setH(100);
      // newItems[0].category == "جديدنا" ||
      // newItems[0].category == "عطور نيش فاخرة" ||
      // newItems[0].category == "عروض مميزة"
      //   ? setScrollEnabled(false)
      //   : setScrollEnabled(true);
    } else if (items.length < 30) {
      // Alert.alert(`الرجاء الانتظار`, `يتم تحميل بعض البيانات`, [
      //   {
      //     text: IMLocalized(`homeScreen.ok`),
      //     onPress: () => {},
      //     style: "default",
      //   },
      // ]);
    } else {
      // Alert.alert(
      //   `${IMLocalized(`globalWord.categoryEmptyTitle`)}`,
      //   `${IMLocalized(`globalWord.categoryEmptyDesc`)}`,
      //   [
      //     {
      //       text: IMLocalized(`homeScreen.ok`),
      //       onPress: () => {},
      //       style: "default",
      //     },
      //   ]
      // );
    }
  };

  // const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    filterItems(categories[newValue]);
  };
  let navigate = useNavigate();

  React.useEffect(() => {
    console.log("done");
    // localStorage.setItem("CountCart", 0);
    // setItems(ddd);
    // console.log("data: ",ddd.productItmes);
    const fetchDataItem = async () => {
      try {
        const { data } = await instance.get(
          "/products/company-limit/62160bc81c5ceec125780794"
        );
        console.log("fetch data item list : ", data[2]);
        // console.log("fetch data item list : ", );
        setItems(data);
        setLoading(false);

        // const {expoTokenAdminUsers} = await dataExpo.data;
        // console.log("expo token admin:  ", expoTokenAdmin);
        // return expoTokenAdminUsers;
      } catch (error) {
        console.log("error data admin: ", error.message);
        // return;
      }
    };
    fetchDataItem();
  }, []);

  const theme = createTheme({
    palette: {
      mode: "dark",
      direction: i18n.dir(),
      primary: {
        main: "#ffffff",
      },
    },
  });

  return (
    <div>
      <ThemeProvider theme={theme}>
        <AppBar
          position="fixed"
          style={{ marginTop: 50, color: "white", textColorPrimary: "green" }}
          color="primary"
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
          >
            {categories.map((category, index) => (
              <Tab
                key={index}
                label={category === "all" ? "كل المنتجات" : category}
              />
            ))}
          </Tabs>
        </AppBar>
      </ThemeProvider>

      <Container style={{ paddingTop: 100, paddingBottom: 100 }}>
        {loading && (
          <Box style={{ textAlign: "center" }}>
            <CircularProgress style={{ color: "gray" }} />
          </Box>
        )}
        <Grid container justifyContent={i18n.dir()} spacing={1}>
          {items
            .filter((item) => item.category === select || select === "all")
            .map((item) => (
              <Grid
                style={{ textAlign: "center" }}
                key={item._id}
                xs={6}
                sm={3}
                md={3}
                lg={2}
              >
                <Item>
                  <Box
                    onClick={() => {
                      cartFull !== 0 &&
                        localStorage.setItem("CountCart", cartFull);
                      navigate(`/${item._id}`);
                    }}
                    component="img"
                    sx={{
                      height: "150px",
                    }}
                    alt={"apple"}
                    src={
                      item.image.includes(",")
                        ? item.image.split(",")[0]
                        : item.image
                    }
                  />
                  <Box m={0} textAlign="left">
                    <Typography gutterBottom variant="h12" component="div">
                      {textCutFunc(item.name)}
                    </Typography>
                    <Typography style={{ color: "green" }} variant="caption">
                      {item.unit.toFixed(2)} ريال
                      <strong
                        style={{
                          textDecorationLine: "line-through",
                          color: "red",
                          paddingRight: "5px",
                        }}
                      >
                        {item.basicPrice.toFixed(2)} ريال
                      </strong>
                    </Typography>
                  </Box>
                  <Button
                    variant="text"
                    sx={{
                      marginTop: 1,
                      backgroundColor: item.stock === 0 ? "#FCEDEF" : "lightgray",
                      color: item.stock === 0 ? "red" : "gray",
                      ":hover": {
                        bgcolor: item.stock === 0 ? "#FCEDEF" : "green", // theme.palette.primary.main
                        color: item.stock === 0 ? "red" : "white",
                      },
                      ":focus": {
                        bgcolor: item.stock === 0 ? "#FCEDEF" : "green", // theme.palette.primary.main
                        color: item.stock === 0 ? "red" : "white",
                      },
                    }}
                    fullWidth
                    startIcon={item.stock === 0 ? null : <AddIcon />}
                    onClick={() =>
                      handleAddProduct(item) & (cartItmes?.length > 0) &&
                      localStorage.setItem("Order", JSON.stringify(cartItmes))
                    }
                  >
                    {item.stock === 0 ? "نفذت الكمية" : "إضافة للسلة"}
                  </Button>
                </Item>
              </Grid>
            ))}
        </Grid>
      </Container>
    </div>
  );
};

export default HomeList;
